import Modal from 'ui3/Modal/Modal';
import Button from 'ui3/Button/Button';
import Switch from 'ui3/Switch/Switch';
// Components
import StreamOptionRow, {
  FAN_ENGAGEMENT_OPTIONS,
  StreamOptionRows,
} from 'components/common3/StreamOptionRow/StreamOptionRow';
// Styles
import styles from './GoLiveOptionsModal.module.scss';

export type GoLiveOptionsModalProps = {
  open: boolean;
  onClose: () => void;
  matchCardSummary: string | null;
  hasMatchCard: boolean;
  onEditMatchCard: () => void;
  fanPollingEnabled: boolean;
  onFanPollingChange: (enabled: boolean) => void;
  sharePickGraphicsEnabled: boolean;
  onSharePickGraphicsChange: (enabled: boolean) => void;
  onSubmit: () => void;
  submitting: boolean;
};

const GoLiveOptionsModal = ({
  open,
  onClose,
  matchCardSummary,
  hasMatchCard,
  onEditMatchCard,
  fanPollingEnabled,
  onFanPollingChange,
  sharePickGraphicsEnabled,
  onSharePickGraphicsChange,
  onSubmit,
  submitting,
}: GoLiveOptionsModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Stream Options"
      titleAlign="left"
      size="small"
      footer={
        <div className={styles.footer}>
          <Button
            variant="primary"
            size="small"
            loading={submitting}
            onClick={onSubmit}
          >
            Set Up Stream
          </Button>
        </div>
      }
    >
      <StreamOptionRows>
        <StreamOptionRow
          title="Match Card"
          description={
            matchCardSummary ??
            'Optional: add bouts so fans can follow and vote on each matchup.'
          }
        >
          <Button variant="secondary" size="small" onClick={onEditMatchCard}>
            {matchCardSummary ? 'Edit' : 'Add Match Card'}
          </Button>
        </StreamOptionRow>

        <StreamOptionRow {...FAN_ENGAGEMENT_OPTIONS.fanPollingEnabled}>
          <Switch
            wrapperClassName={styles.switch}
            name="fanPollingEnabled"
            checked={fanPollingEnabled}
            disabled={!hasMatchCard}
            onChange={(event) => onFanPollingChange(event.target.checked)}
          />
        </StreamOptionRow>

        <StreamOptionRow {...FAN_ENGAGEMENT_OPTIONS.sharePickGraphicsEnabled}>
          <Switch
            wrapperClassName={styles.switch}
            name="sharePickGraphicsEnabled"
            checked={sharePickGraphicsEnabled}
            disabled={!hasMatchCard}
            onChange={(event) =>
              onSharePickGraphicsChange(event.target.checked)
            }
          />
        </StreamOptionRow>
      </StreamOptionRows>
    </Modal>
  );
};

export default GoLiveOptionsModal;
